<template>
  <div class="item">
    <form-switch v-if="isBoolean" :errors="errors" v-model="rules[name]" model="plan" :name="name" :value="value"/>

    <field v-else :errors="errors" :required="true" model="plan" :name="name" v-model="rules[name]" :value="value"></field>
  </div>
</template>
<script>
import Field from '@/components/helpers/DataInput/Field'
import FormSwitch from '@/components/helpers/DataInput/FormSwitch'

export default {
  props: {
    name: {
      type: String
    },
    value: {},
    rules: {
      type: Object
    }
  },
  components: {
    Field,
    FormSwitch
  },
  data(){
    return {
      errors: []
    }
  },
  computed: {
    isBoolean() {
      let potentialBoolValue = this.value === 'true' ? true :
                               this.value === 'false' ? false :
                               this.value;
      return typeof potentialBoolValue === 'boolean'
    }
  }
}
</script>



// WEBPACK FOOTER //
// PlanRuleListItem.vue?4aa1c50a